import * as React from 'react';
import PropTypes from 'prop-types';


interface IServicesProviderProps {
  services: object;
}

export default class ServicesProvider extends React.Component<IServicesProviderProps> {
  public static childContextTypes = {
    services: PropTypes.object,
  };

  public getChildContext() {
    const { services } = this.props;

    return { services };
  }

  public render() {
    const { children } = this.props;

    return (
      <React.Fragment>
        {children}
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ServicesProvider.tsx